<div
  *ngIf="showError || showErrorTime || showErrorCustomForm || showErrorinfoForm"
  style="padding-left: 5%; padding-right: 5%"
  class="pb-2 mobile-error"
>
  <app-error-message
    *ngIf="showError"
    [message]="'choose-ticket-first' | translate"
    (dismissed)="showError = false"
  ></app-error-message>
  <app-error-message
    *ngIf="showErrorTime"
    (dismissed)="showErrorTime = false"
    [message]="'choose-time-error' | translate"
  ></app-error-message>
  <app-error-message
    *ngIf="showErrorCustomForm"
    (dismissed)="showErrorCustomForm = false"
    [message]="'custom-form-error' | translate"
  ></app-error-message>
  <app-error-message
    *ngIf="showErrorinfoForm"
    [message]="'enter-valid-info' | translate"
    (dismissed)="showErrorinfoForm = false"
  ></app-error-message>
</div>
<div class="d-flex justify-content-between book-footer">
  <div class="d-flex gap-1 align-items-center mobile-footer">
    <span
      *ngIf="ticketService.getTotalPriceInCart() != 0 && isMobile"
      class="total-amount"
      style="font-size: large"
      >{{ "total-price" | translate }} :
    </span>
    <button (click)="payNow()" class="btn pay-now-btn">
      <i
        *ngIf="translateService.currentLang == 'ar'"
        class="fas fa-arrow-right me-2"
      ></i>
      <i
        *ngIf="translateService.currentLang == 'en'"
        class="fas fa-arrow-left me-2"
      ></i>

      {{ "continue-order" | translate }}
    </button>
    <div
      class="d-flex gap-1"
      *ngIf="
        ticketService.getTotalPriceInCart() != 0 &&
        !isMobile &&
        router.url.includes('sport')
      "
    >
      <p
        class="mb-0 font-weight-bold"
        style="font-size: large; color: #555770"
        [ngClass]="
          !ticketService.checkNeedToPay() &&
          ticketService.getTotalPriceInCart() > 0
            ? 'not-need-to-pay'
            : ''
        "
      >
        <span
          [innerHTML]="
            ticketService.getTotalPriceInCart()
              | toVat
              | number : '1.2-2'
              | customCurrency : 'SAR' : 'symbol' : '#555770' : 30
          "
        ></span>
      </p>
      <p
        *ngIf="
          !ticketService.checkNeedToPay() &&
          ticketService.getTotalPriceInCart() > 0
        "
        class="mb-0 font-weight-bold"
        style="font-size: large; color: red"
      >
        {{ "free" | translate }}
      </p>
    </div>
    <p
      class="mb-0 font-weight-bold"
      style="font-size: large; color: #555770"
      *ngIf="
        ticketService.getTotalPriceInCart() != 0 &&
        !isMobile &&
        !router.url.includes('sport')
      "
    >
      <span class="total-amount">{{ "total-price" | translate }} : </span>
      <span
        [innerHTML]="
          ticketService.bookTicket.getValue()?.totalwithdiscount
            ? (ticketService.getTotalPriceInCart()
              | customCurrency : 'SAR' : 'symbol' : '#555770' : 30)
            : (ticketService.getTotalPriceInCart()
              | toVat
              | number : '1.2-2'
              | customCurrency : 'SAR' : 'symbol' : '#555770' : 30)
        "
      ></span>
    </p>
  </div>
  <div class="d-flex mobile-footer" style="gap: 15px">
    <div
      class="d-flex gap-1"
      *ngIf="
        ticketService.getTotalPriceInCart() != 0 &&
        isMobile &&
        router.url.includes('sport')
      "
    >
      <p
        class="mb-0 font-weight-bold text-end"
        style="font-size: x-large; color: #555770"
        [ngClass]="
          !ticketService.checkNeedToPay() &&
          ticketService.getTotalPriceInCart() > 0
            ? 'not-need-to-pay'
            : ''
        "
      >
        <span
          [innerHTML]="
            ticketService.getTotalPriceInCart()
              | toVat
              | number : '1.2-2'
              | customCurrency : 'SAR' : 'symbol' : '#555770' : 30
          "
        ></span>
      </p>
      <p
        *ngIf="
          !ticketService.checkNeedToPay() &&
          ticketService.getTotalPriceInCart() > 0
        "
        class="mb-0 font-weight-bold text-end"
        style="font-size: x-large; color: red"
      >
        {{ "free" | translate }}
      </p>
    </div>
    <p
      class="mb-0 font-weight-bold text-end"
      style="font-size: x-large; color: #555770"
      *ngIf="
        ticketService.getTotalPriceInCart() != 0 &&
        isMobile &&
        !router.url.includes('sport')
      "
    >
      <span
        [innerHTML]="
          ticketService.bookTicket.getValue()?.totalwithdiscount
            ? (ticketService.getTotalPriceInCart()
              | customCurrency : 'SAR' : 'symbol' : '#555770' : 30)
            : (ticketService.getTotalPriceInCart()
              | toVat
              | number : '1.2-2'
              | customCurrency : 'SAR' : 'symbol' : '#555770' : 30)
        "
      ></span>
    </p>

    <div (click)="cancel()" class="d-flex gap-1 cancel align-items-center">
      <i class="fa fa-close"></i>
      <span> {{ "cancel-reserve" | translate }} </span>
    </div>
  </div>
</div>
